/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';
// import { FaInfoCircle } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} arrow classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        backgroundColor: theme.palette.white,
        fontSize: 14,
        '&::before': {
            border: '1px solid #E9E9E9',
            color: theme.palette.black.dark,
            backgroundColor: theme.palette.white,
            boxSizing: 'border-box',
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        },
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.white,
        color: theme.palette.black.dark,
        border: '1px solid #E9E9E9',
        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        fontSize: '10px',
    },
}));

const InfoImg = (props) => {
    const { title, placement, className } = props;
    return (
        <StyledTooltip arrow title={title} placement={placement} className={`custom-${className}`}>
            <Box component="span" className={className} sx={{ marginTop: '6px !important' }}>
                {/* <FaInfoCircle style={{ color: '#0047BA', fontSize: '20px', marginTop: '5px' }} /> */}
                <img src="/static/images/info_blue.svg" alt="" width={22} />
            </Box>
        </StyledTooltip>
    );
};

InfoImg.propTypes = {
    className: PropTypes.string,
    title: PropTypes.any,
    placement: PropTypes.any,
};

InfoImg.defaultProps = {
    className: '',
    title: '',
    placement: 'bottom',
};

export default React.memo(InfoImg);
